import { render, staticRenderFns } from "./dialogSendInfo.vue?vue&type=template&id=6e165d5c&"
import script from "./dialogSendInfo.vue?vue&type=script&lang=js&"
export * from "./dialogSendInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogSendInfo.vue?vue&type=style&index=0&id=6e165d5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports